module.exports = __webpack_public_path__ + "img/愛心傘系統.f05abf26.jpg";